<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
    import moment from 'moment'
    import 'moment/locale/zh-cn'
    import { getExportTasksByIds } from '@/api/system/task.api'

    const EXPORT_TASK_POLL_INTERVAL = 5000

    moment.locale('zh-cn')

    export default {
        name: 'App',
        data() {
            return {
                locale: zhCN,
                exportTaskTimer: null,
                exportTaskPolling: false
            }
        },
        computed: {
            userLang() {
                return this.$store.getters.userLang
            },
            exportTaskIds() {
                return this.$store.getters.exportTaskIds || []
            }
        },
        watch: {
            userLang() {
                this.locale = zhCN
            },
            exportTaskIds: {
                immediate: true,
                handler(taskIds) {
                    if (taskIds.length) {
                        this.startExportTaskPolling()
                    } else {
                        this.stopExportTaskPolling()
                    }
                }
            }
        },
        methods: {
            startExportTaskPolling() {
                if (this.exportTaskTimer || !localStorage.getItem('token')) return
                this.exportTaskTimer = window.setInterval(this.pollExportTasks, EXPORT_TASK_POLL_INTERVAL)
            },
            stopExportTaskPolling() {
                if (this.exportTaskTimer) window.clearInterval(this.exportTaskTimer)
                this.exportTaskTimer = null
            },
            async pollExportTasks() {
                const taskIds = this.exportTaskIds.slice()
                if (!taskIds.length || this.exportTaskPolling) return
                this.exportTaskPolling = true
                try {
                    const res = await getExportTasksByIds(taskIds)
                    if (!res || Number(res.code) !== 200 || !Array.isArray(res.data)) return
                    const completedTasks = res.data.filter(task => ['1', '2'].indexOf(String(task.taskStatus)) !== -1)
                    completedTasks.forEach(this.notifyExportTask)
                    if (completedTasks.length) {
                        this.$store.dispatch('removeCompletedExportTasks', completedTasks.map(task => task.taskId))
                    }
                } catch (error) {
                    // 请求层已统一提示错误，保留任务供下次轮询重试
                } finally {
                    this.exportTaskPolling = false
                }
            },
            notifyExportTask(task) {
                const success = String(task.taskStatus) === '1'
                const downloadUrl = success ? this.buildDownloadUrl(task.downloadSrc) : ''
                const config = {
                    message: success ? '文件导出成功' : '文件导出失败',
                    description: success
                        ? `${task.taskName || '导出文件'}已生成${downloadUrl ? '，点击通知即可下载' : ''}`
                        : (task.failReason || `${task.taskName || '导出任务'}处理失败`),
                    duration: 6
                }
                if (downloadUrl) config.onClick = () => window.open(downloadUrl, '_blank')
                this.$notification[success ? 'success' : 'error'](config)
            },
            buildDownloadUrl(url) {
                if (!url) return ''
                if (/^(https?:)?\/\//.test(url) || url.indexOf('/') === 0) return url
                const host = (this.importTemplateHost || '').replace(/\/$/, '')
                return host ? `${host}/${encodeURI(url)}` : encodeURI(url)
            }
        },
      mounted() {
        this.locale = zhCN
        if (localStorage.getItem('lang') !== 'zh-CN') {
          localStorage.setItem('lang', 'zh-CN')
        }
      },
      beforeDestroy() {
        this.stopExportTaskPolling()
      }
    }
</script>

<style>
  html,
  body {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow: hidden;
  }

  #app {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue